import { labQueueToken } from '../../constants/lab';

/**
 * labCardIdentity — THE single projection for "who is this lab order about"
 * (S3). Both the queue card, the block header context and the collect-sample
 * dialog read identity through this one function — no per-surface re-derive
 * (LAB-ASSIGN-2 §10.4/§10.6).
 *
 * Every field is OMITTED (returned `undefined`), never blanked to `null` or
 * `''`, when the underlying value is absent — orders created before S4
 * shipped (or an unresolvable patient/admission row) simply lack
 * `patient_mobile` / `uhid` / `ward_bed_label`; the caller renders no line
 * for it rather than a placeholder (frozen copy, §10.6: "line omitted
 * entirely — never blank, never 'null', never a placeholder").
 *
 * `labToken` reuses `labQueueToken()` (the existing SSOT for `#L-n`, already
 * driving lane sort + the block header) rather than re-deriving the
 * `lab_queue_number ?? queue_number` fallback a second time. `opdToken` is
 * only surfaced as a DISTINCT value when a real `lab_queue_number` exists
 * alongside a `queue_number` — otherwise `labToken` already IS the OPD
 * number (legacy fallback) and repeating it as "(Q-n)" would just echo the
 * same figure twice.
 *
 * @param {object} order
 * @returns {{
 *   name: (string|undefined), mobile: (string|undefined), uhid: (string|undefined),
 *   labToken: (number|undefined), opdToken: (number|undefined),
 *   receipt: (string|undefined), ipNumber: (string|undefined), wardBed: (string|undefined),
 * }}
 */
export default function labCardIdentity(order) {
  const o = order || {};
  const str = (v) => {
    if (v === null || v === undefined) return undefined;
    const s = String(v).trim();
    return s ? s : undefined;
  };
  const labToken = labQueueToken(o);
  const hasDistinctOpdToken = o.lab_queue_number != null && o.queue_number != null;

  return {
    name: str(o.patient_name),
    mobile: str(o.patient_mobile),
    uhid: str(o.uhid),
    labToken: labToken != null ? labToken : undefined,
    opdToken: hasDistinctOpdToken ? o.queue_number : undefined,
    receipt: str(o.receipt_number_printed ?? o.receipt_number),
    ipNumber: str(o.ip_number),
    wardBed: str(o.ward_bed_label),
  };
}
